import { BaseAnalyticsEvent } from "../types";

declare global {
	interface Window {
		ym?: (...args: any[]) => void;
	}
}

/**
 * Отправка события в Яндекс.Метрику
 * @param counterId ID счётчика
 * @param event событие
 */
export function sendToYandexMetrika(counterId: number, event: BaseAnalyticsEvent) {
	if (!window.ym) return;
	try {
		window.ym(counterId, "reachGoal", event.eventName, event);
	} catch (err) {
		if (process.env.NODE_ENV === "development") {
			console.warn("[Analytics] Yandex Metrika error", err);
		}
	}
}
